module.exports = {
  "midea-swipe-cell": {
    "position": "relative",
    "width": "750",
    "overflow": "hidden"
  },
  "midea-swipe-cell__wrapper": {
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "justifyContent": "space-between",
    "alignItems": "center",
    "boxSizing": "content-box"
  },
  "midea-swipe-cell__left": {
    "height": "96",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#ff4444",
    "fontSize": "16",
    "color": "#ffffff"
  },
  "midea-swipe-cell__right": {
    "height": "96",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "#ff4444",
    "fontSize": "16",
    "color": "#ffffff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1d8cb49c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/swipe-cell/index.vue
// module id = 431
// module chunks = 0 1